import { render, staticRenderFns } from "./image-frame.vue?vue&type=template&id=547e6eac&scoped=true&"
import script from "./image-frame.vue?vue&type=script&lang=js&"
export * from "./image-frame.vue?vue&type=script&lang=js&"
import style0 from "./image-frame.vue?vue&type=style&index=0&id=547e6eac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547e6eac",
  null
  
)

export default component.exports